import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
import { errorMessageGenerator, creator } from 'uwork-app-core';

/**
 * Constants
 */
export const REQUEST = '@app/dashoard/lastSeenStats/REQUEST';
export const SUCCESS = '@app/dashoard/lastSeenStats/SUCCESS';
export const FAILURE = '@app/dashoard/lastSeenStats/FAILURE';

/**
 * Initial state
 */
const initState = {
    stats: {},
    statsLoading: false
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.statsLoading = true;
                break;
            case SUCCESS:
                draft.stats = payload.data;
                draft.statsLoading = false;
                break;
            case FAILURE:
                draft.statsLoading = false;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: () => creator(REQUEST),
    failure: () => creator(FAILURE),
    success: (data) => creator(SUCCESS, data)
};

/**
 * Sagas
 */
export const sagas = {
    *request() {
        try {
            const response = yield axios.get('/last-seen-activity/metrics');
            yield put(actions.success(response.data));
        } catch (e) {
            console.error(errorMessageGenerator(e));
            yield put(actions.failure());
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
